// extracted by mini-css-extract-plugin
export default {"devices_Container":"devices_devices_Container__WP1Bv","content_wrapper":"devices_content_wrapper__4wzE1"};